module.exports = {
  siteTitle: 'ActiveLAMP', // Site title.
  siteTitleShort: 'ActiveLAMP', // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: 'ActiveLAMP Web Experts', // Alternative site title for SEO.
  siteLogo: '/logos/activelamp-icon.png', // Logo used for SEO and manifest.
  siteLogoSVG: '/logos/activelamp-logo.svg', // Logo used for header.
  siteUrl: 'https://activelamp.com', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter/.
  fixedFooter: false, // Whether the footer component is fixed, i.e. always visible
  siteDescription:
    'ActiveLAMP is a web development & digital strategy firm in Los Angeles, helping businesses achieve their digital goals. Call 310-943-0246 for details.', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml', // Path to the RSS file.
  siteFBAppID: '1825356251115265', // FB Application ID for using app insights
  siteGATrackingID: 'UA-5593567-1', // Tracking code ID for google analytics.
  disqusShortname: 'activelamp', // Disqus shortname.
  postDefaultCategoryID: 'development', // Default category for posts.
  dateFromFormat: 'YYYY-MM-DD HH:mm:ss Z', // Date format used in the frontmatter.
  dateFormat: 'LL', // Date format for display.
  userName: 'ActiveLAMP', // Username to display in the author segment.
  userTwitter: '', // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: 'Los Angeles, CA', // User location to display in the author segment.
  //Site Key google ReCAPTCHA
  googleRecaptchaSiteKey: '6Lf7CFMpAAAAAFC9jS-_HOdG2QPdj7GeoENZ7nxT',
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  metaTags: {
    home: 'Technical Consulting, Design, and Development Firm',
    blogLanding: 'Blog',
    videoLanding: 'Videos',
    blogCategory: 'Blog - Category:',
    blogTag: 'Blog - Tag:',
    video: 'Videos',
  },
  navLinks: [
    {
      label: 'what we do',
      iconClassName: '',
      url: '/what-we-do',
    },
    {
      label: 'our work',
      iconClassName: '',
      url: '/portfolio',
    },
    {
      label: 'video',
      iconClassName: '',
      url: '/video',
    },
    {
      label: 'blog',
      iconClassName: '',
      url: '/blog',
    },
    {
      label: 'contact',
      iconClassName: '',
      url: '/contact',
    },
  ],
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  socialLinks: [
    {
      label: 'Twitter',
      url: 'https://twitter.com/activelamp',
      iconClassName: 'fa fa-twitter',
    },
    {
      label: 'LinkedIn',
      url: 'https://www.linkedin.com/company/activelamp/about/',
      iconClassName: 'fa fa-linkedin',
    },
    {
      label: 'YouTube',
      url: 'https://www.youtube.com/activelamp',
      iconClassName: 'fa fa-youtube',
    },
    {
      label: 'GitHub',
      url: 'https://github.com/activelamp',
      iconClassName: 'fa fa-github',
    },
    {
      label: 'Facebook',
      url: 'https://www.facebook.com/activelamp/',
      iconClassName: 'fa fa-facebook',
    },
    {
      label: 'Instagram',
      url: 'https://www.instagram.com/weareactivelamp/',
      iconClassName: 'fa fa-instagram',
    },
  ],
  clientList: [
    {
      client: 'Riot Games',
      url: '/projects/league-of-legends-esports',
      img: 'logo-garden-riot',
    },
    {
      client: 'XPRIZE',
      url: '/projects/xprize-foundation',
      img: 'logo-garden-xprize',
    },
    {
      client: 'AARP',
      url: '/projects/aarp-create-the-good',
      img: 'logo-garden-aarp',
    },
    {
      client: "Cesar's Way",
      url: '/projects/cesar-millan',
      img: 'logo-garden-ceasars',
    },
    {
      client: 'Mike Thompson RV',
      url: '/projects/mike-thompson-rv-super-stores',
      img: 'logo-garden-mtrv',
    },
    {
      client: 'Postbox',
      url: '/projects/postbox',
      img: 'logo-garden-post',
    },
    {
      client: 'Americas Promise',
      url: '/projects/americaspromise',
      img: 'logo-garden-apa',
    },
    {
      client: 'UCLA',
      url: '/projects/ucla',
      img: 'logo-garden-ucla',
    },
    {
      client: 'Stimson',
      url: '/projects/stimson',
      img: 'logo-garden-stim',
    },
  ],
  copyright: 'All Rights Reserved by ActiveLAMP', // Copyright string for the footer of the website and RSS feed.
}
